
import { Vue, Component, Emit, Prop } from 'vue-property-decorator';

@Component({
    name: 'DisabledPlateDialog',
    components: {},
})
export default class DisabledPlateDialog extends Vue {
    @Prop({
        type: String,
        default: '',
    })
    private plate!: string;

    @Emit('close')
    public close() {
        return true;
    }
}
